import React, { useState, useEffect } from 'react';
import { MailTemplateEditor } from './editor';
import { PreviewContent } from '../../components/preview/privew';
import Group from './group/group';
import ManageGroup from './group/manageGroup';
import DeleteConfirm from './group/confirmModal';
import classes from './index.module.scss';
import { Input, Button, Tooltip, message } from 'antd';
import { ReactComponent as IconClose } from '@/images/icons/edm/template-group-close.svg';
import { useActions, MailTemplateActions } from '@web-common/state/createStore';
import { apiHolder as api, apis } from 'api';
import { getIn18Text } from 'api';
import { edmDataTracker } from '../../tracker/tracker';
import { guardString } from '../../utils';
let editorInstance;
let editMailReq = {
    templateName: '',
};
const templateApi = api.api.requireLogicalApi(apis.mailTemplateImplApi);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const MaxNameLength = 50;
export const TemplateAddModal = (props) => {
    const { changeShowTemplateList } = useActions(MailTemplateActions);
    const { templateId, goMailTemplate, templateInfo, content, doUseTemplate, successLabel } = props;
    const [templateTitle, setTemplateTitle] = useState('');
    const [templateName, setTemplateName] = useState('');
    const [originTagIds, setOriginTagIds] = useState([]);
    const [selectedTagIds, setSelectedTagIds] = useState([]);
    const [manageVisible, setManageVisible] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [previewContent, setPreviewContent] = useState('');
    const [isModified, setIsModified] = useState(false);
    const changeName = (e) => {
        let { value } = e.target;
        if (value.length > MaxNameLength) {
            message.error({
                content: getIn18Text('QINGSHURU50'),
            });
            value = value.slice(0, MaxNameLength);
        }
        setTemplateName(value);
    };
    useEffect(() => {
        if (content && editorInstance) {
            editorInstance.setContent(content);
        }
    }, [content]);
    const doSaveMailTemplate = () => {
        if (!templateName.trim() || templateName.length > 50) {
            message.error({
                content: templateName.length > 50 ? getIn18Text('MUBANMINGCHENGZUIDKSR50GZF！') : getIn18Text('QINGSHURUMOBANMINGCHENG!'),
            });
            return;
        }
        let params = {
            templateId: templateId || '',
            templateName,
            templateCategory: 'LX-WAIMAO',
            content: (editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.getContent()) || '',
            tagIdList: selectedTagIds,
        };
        if (templateId && Object.keys(editMailReq).length > 0) {
            const { bcc, to, cc, subject } = editMailReq;
            params = Object.assign(params, { subject, to, bcc, cc });
        }
        templateApi.doSaveMailTemplate(params).then(res => {
            if (res.success && res.data) {
                const content1 = (React.createElement(React.Fragment, null,
                    successLabel ? React.createElement("span", null, successLabel) : React.createElement("span", null, getIn18Text('BAOCUNCHENGGONG')),
                    templateInfo && templateInfo.from === 'taskMail' && (React.createElement("span", { style: { marginLeft: '8px', color: '#4C6AFF', cursor: 'pointer' }, onClick: () => {
                            var _a;
                            doUseTemplate && doUseTemplate(((_a = res.data) === null || _a === void 0 ? void 0 : _a.templateId) || '');
                        } }, getIn18Text('QUSHIYONGMUBAN')))));
                message.success({
                    content: content1,
                });
                goMailTemplate(true);
                trackApi.track('pc_markting_edm_template_newobject_click', {
                    operation: !templateId ? 'newobject' : 'edit',
                    method: content ? getIn18Text('CONGYINGXIAORENWUXUANZE') : getIn18Text('SHOUDONGXINJIAN'),
                });
                if (templateInfo && templateInfo.from === 'taskMail') {
                    trackApi.track('pc_markting_edm_taskdetail_save_as_template_click');
                }
            }
            else {
                message.error({
                    content: res.message || getIn18Text('BAOCUNSHIBAI\uFF01'),
                });
            }
        });
    };
    const doGetMailTemplateDetail = (needStatistics = false) => {
        if (!templateId)
            return;
        editMailReq = {
            templateName: '',
        };
        templateApi.doGetMailTemplateDetail({ templateId: templateId, needStatistics }).then(res => {
            if (res.success && res.data) {
                const { templateName, content, tagList } = res.data;
                editMailReq = res.data;
                const tagIds = tagList.map(tag => {
                    return tag.tagId;
                });
                setTemplateName(templateName);
                editorInstance.setContent(content);
                setOriginTagIds(tagIds);
                setSelectedTagIds(tagIds);
            }
        });
    };
    const getEditorInstance = (editor) => {
        editorInstance = editor;
        if (content && editorInstance) {
            editorInstance.setContent(content);
        }
        if (!!templateInfo && Object.keys(templateInfo).length > 0) {
            setOriginAttrs(templateInfo);
        }
        if (!!templateId) {
            doGetMailTemplateDetail(false);
        }
    };
    const setOriginAttrs = (templateInfo) => {
        for (const key in templateInfo) {
            switch (key) {
                case 'title':
                    const title = getIn18Text('BAOCUNWEIMUBAN');
                    setTemplateTitle(title);
                    break;
                case 'content':
                    editorInstance.setContent(templateInfo['content']);
                    break;
                case 'templateName':
                    setTemplateName(templateInfo[key]);
                    break;
                case 'tagIds':
                    setOriginTagIds(templateInfo[key]);
                    setSelectedTagIds(templateInfo[key]);
                    break;
            }
        }
    };
    const handleSelectedIds = (ids) => {
        setSelectedTagIds(ids);
    };
    const beforeClose = () => {
        if (isModified || editMailReq.templateName !== templateName || content) {
            setShowConfirm(true);
            return;
        }
        goMailTemplate(false);
    };
    const handleDeleteConfirm = () => {
        goMailTemplate(false);
        setShowConfirm(false);
        if (content) {
            changeShowTemplateList && changeShowTemplateList({ isShow: false });
        }
    };
    const previewInEdit = () => {
        edmDataTracker.templatePageOp('preview', '');
        if (!editorInstance)
            return;
        const html = editorInstance.__getPreviewHtml__ ? editorInstance.__getPreviewHtml__(editorInstance) : editorInstance.getContent();
        let title = '';
        if (templateName) {
            title = `<h1 style="font-size: 16px; padding: 30px 0 20px; font-weight:500; margin:0">${templateName}</h1>`;
        }
        setPreviewContent(`${title}${html}`);
    };
    useEffect(() => {
        let title = getIn18Text('XINJIANZIDINGYIMOBAN');
        if (content !== '') {
            title = getIn18Text('BAOCUNWEIYOUJIANMUBAN');
        }
        if (templateId) {
            title = getIn18Text('BIANJIMOBAN');
        }
        else {
            if (!!templateInfo && Object.keys(templateInfo).length > 0) {
                title = getIn18Text('BAOCUNWEIYOUJIANMUBAN');
            }
        }
        setTemplateTitle(title);
    }, [templateId, templateInfo]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `${classes.template} add-mail-template-modal` },
            React.createElement("div", { className: classes.header },
                React.createElement("div", { className: classes.title }, templateTitle),
                React.createElement("div", { className: classes.close },
                    React.createElement(IconClose, { style: { cursor: 'pointer' }, onClick: beforeClose }))),
            React.createElement("div", { className: classes.nav },
                React.createElement("div", { className: classes.templateName },
                    React.createElement("span", { className: classes.label }, getIn18Text('MOBANMINGCHENG:')),
                    React.createElement(Input, { className: classes.input, placeholder: getIn18Text('QINGSHURUMOBANMINGCHENG'), value: templateName, onChange: changeName })),
                React.createElement("div", { className: classes.line }),
                React.createElement("div", { className: classes.group },
                    React.createElement(Group, { originTagIds: originTagIds, manageVisible: manageVisible, sendSelectedIds: ids => {
                            handleSelectedIds(ids);
                        }, manageGroup: () => {
                            setManageVisible(true);
                        } }))),
            React.createElement("div", { className: classes.container },
                React.createElement(MailTemplateEditor, { changeMailContent: () => {
                        setIsModified(true);
                    }, getEditorInstance: getEditorInstance })),
            React.createElement("div", { className: classes.footer },
                React.createElement(Button, { style: { marginRight: '12px' }, onClick: beforeClose }, getIn18Text('QUXIAO')),
                React.createElement(Tooltip, { title: !templateName ? getIn18Text('TIANJIAMOBANMINGCHENGCAIKEYULAN') : '' },
                    React.createElement(Button, { style: { marginRight: '12px' }, onClick: previewInEdit, disabled: !templateName }, getIn18Text('YULAN'))),
                React.createElement(Button, { type: "primary", onClick: doSaveMailTemplate, disabled: !templateName }, getIn18Text('BAOCUNMOBAN')))),
        React.createElement(ManageGroup, { visible: manageVisible, closeModal: () => {
                setManageVisible(false);
            } }),
        React.createElement(DeleteConfirm, { showConfirm: showConfirm, setShowConfirm: setShowConfirm, handleConfirm: handleDeleteConfirm }),
        guardString(previewContent) && React.createElement(PreviewContent, { content: previewContent, onCancel: () => setPreviewContent('') })));
};
export default TemplateAddModal;
